<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10enWVe/tc-custom/9781467452625.jpg?1728851852910" alt="This image is the cover for the book Human Rites"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Human Rites
      </h1>
      <p class="bookDescription body article font2">
        <p>What are we doing when we gather around the sacraments— or when we make the same breakfast every morning? Embodying rituals, says Dru Johnson. And until we understand what we’re doing and why, we won’t know how these rituals work, what they mean, or how we might adapt them.</p><p>In <i>Human Rites </i>Johnson considers the concept of ritual as seen in Scripture and its role in shaping our thinking. He colorfully illustrates both the mundane and the sacred rituals that penetrate all of life, offering not only a helpful introduction to rituals but also a framework for understanding them. As he unpacks how rituals pervade every area of our lives, Johnson suggests biblical ways to focus our use of rituals, habits, and sacraments so that we can see the world more truly through them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dru Johnson, David Dark
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Dru Johnson</B>&#160;is an associate professor of biblical and theological studies at The King&#39;s College in New York City. Before that, he was a high-school dropout, skinhead, punk rock drummer, combat veteran, IT supervisor, and pastor-all things that he hopes none of his children ever become.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4de4fae2